import { ElementRef, Input } from '@angular/core';
import { Directive } from '@angular/core';
import { AfterViewInit, Injector } from '@angular/core';
import { MatFormField, MatFormFieldControl } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslateService } from '@ngx-translate/core';
import { FormFieldValidator } from '../../model/form-field-element';

@Directive({
  selector: '[appMatErrorMessages]'
})
export class MatErrorMessagesDirective implements AfterViewInit {

  @Input('appMatErrorMessages') formFieldValidators: FormFieldValidator[] | null;

  inputRef: MatFormFieldControl<MatInput>;

  constructor(private elementRef: ElementRef, private injector: Injector, private translate: TranslateService) { }

  // Setup all initial tooling
  ngAfterViewInit(): void {
    // grab reference to MatFormField directive, where form control is accessible.
    const container = this.injector.get(MatFormField);
    this.inputRef = container._control;

    // sub to the control's status stream
    this.inputRef.stateChanges.subscribe(() => {
      const controlErrors = this.inputRef.ngControl.errors;
      if (controlErrors) {
        const errors = Object.keys(controlErrors);
        for (const validatorObject of this.formFieldValidators) {
          if (errors.includes(validatorObject.validatorErrorName)) {
            const errorParams = controlErrors[validatorObject.validatorErrorName];
            this.translate.get(
              validatorObject.errorKey, {...validatorObject.errorParams, ...errorParams}).subscribe(error => this.elementRef.nativeElement.innerText = error
              );
            break;
          }
        }
      }
    });
  }

}
